import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { KeyValue } from '../../shared/key-value';
import { Router } from '@angular/router';

import { AuthorizationService } from '../../shared/authorization.service';

declare function init_input_check(): void;

@Component({
  selector: 'forgot-password',
  templateUrl: 'forgot-password.component.html'
})
export class ForgotPasswordComponent {
  email: string;
  public erroremailMsg = ''
  private maxAttempts = 3;
  private lockoutTime = 15 * 60 * 1000;
  currentYearCopyRight: number = new Date().getFullYear();

  constructor(private router: Router, private _tokenService: AngularTokenService, private authService: AuthorizationService) { }

  EmailSent() {
    this.router.navigate(['/forgot-password-submit']);
  }

  ErrorEmail() {
    this.erroremailMsg = "Enter valid email registered for this program."
  }

  ngOnInit() {
    setTimeout(function () {
      init_input_check();
    }, 1000);
  }

  // To check logout attempt and time remaning to next submit
  checkLockout() {
    const attempts = localStorage.getItem('forgotPasswordAttempts');
    const lockoutExpiration = localStorage.getItem('forgotPasswordLockout');
    console.log("*******************************************************************")
    console.log("Attempt: " + attempts)
    if (attempts && parseInt(attempts) >= this.maxAttempts) {
      const lockoutTime = lockoutExpiration ? parseInt(lockoutExpiration) : 0;
      const currentTime = new Date().getTime();
      if (currentTime < lockoutTime) {
        const remainingTime = Math.ceil((lockoutTime - currentTime) / 1000 / 60);
        this.erroremailMsg = `Too many attempts. Please try again in ${remainingTime} minutes.`;
        return true;
      } else {
        localStorage.removeItem('forgotPasswordAttempts');
        localStorage.removeItem('forgotPasswordLockout');
        return false;
      }
    }
    return false;
  }

  // To check login and increase the attempt
  increaseAttempt() {
    const attempts = localStorage.getItem('forgotPasswordAttempts');
    let attemptCount = attempts ? parseInt(attempts) : 0;
    attemptCount += 1;
    localStorage.setItem('forgotPasswordAttempts', attemptCount.toString());

    if (attemptCount >= this.maxAttempts) {
      const lockoutExpiration = new Date().getTime() + this.lockoutTime;
      localStorage.setItem('forgotPasswordLockout', lockoutExpiration.toString());
    }
  }

  submit_forgot_password() {
    if (this.checkLockout()) {
      return;
    }

    this._tokenService.resetPassword({
      login: this.email
    }).subscribe(
      () => {
        this.authService.post(KeyValue.api_after_password_recovery, { params: { user_email: this.email } }).pipe(map(res => res)).subscribe(
          () => {
            localStorage.setItem('current_email', JSON.stringify(this.email));
            this.EmailSent();
            localStorage.removeItem('forgotPasswordAttempts'); // Clear attempts on success
          },
          () => this.router.navigate([KeyValue.signinPath])
        );
      },
      () => {
        this.ErrorEmail();
        this.increaseAttempt(); // Increase attempt count on failure
      }
    );
  }

  ForgotPassword(): void {
    this.erroremailMsg = '';
    if (this.email != '' && this.email != undefined) {
      this.submit_forgot_password();
    } else {
      this.erroremailMsg = "Please input your Email to proceed.";
    }
  }
}
